import TasksModule from '@modules/TasksModule';
import ServiceModule from '@modules/ServiceModule';
import { InboxContext } from '@modules/InboxModule/types';
import { PcsConversationDetailsResult } from '@api/queries/getPcsConversationDetails';

/**
 * Calculates the agent timeout timestamp based on queue settings
 */
function calculateAgentTimeoutAt(
  queueId: string | undefined,
  sessionOfferedAt: string | null | undefined,
): number | undefined {
  if (!queueId || !sessionOfferedAt) {
    return undefined;
  }

  const queue = ServiceModule.getQueue(queueId);
  if (!queue?.agentTimeout) {
    return undefined;
  }

  const sessionOfferedTime = new Date(sessionOfferedAt).getTime();
  if (Number.isNaN(sessionOfferedTime)) {
    return undefined;
  }

  // Parse "hh:mm:ss" format
  const timeParts = queue.agentTimeout.split(':').map(Number);
  if (timeParts.length !== 3 || timeParts.some((part) => Number.isNaN(part))) {
    return undefined;
  }

  const [hours, minutes, seconds] = timeParts;
  const timeoutSeconds = hours * 3600 + minutes * 60 + seconds;

  if (timeoutSeconds <= 0) {
    return undefined;
  }

  return sessionOfferedTime + timeoutSeconds * 1000;
}

function handleCallDetailsFetched(
  _context: InboxContext,
  callId: string,
  conversationDetails: PcsConversationDetailsResult,
) {
  const task = TasksModule.getTaskByCallId(callId);

  if (!task) {
    return;
  }

  const agentTimeoutAt = calculateAgentTimeoutAt(
    task.queueId,
    conversationDetails.sessionOfferedAt,
  );

  // Always update with conversationDetails
  TasksModule.updateTaskAttributes(task.id, {
    conversationDetails,
    ...(agentTimeoutAt !== undefined && { agentTimeoutAt }),
  });
}

export default handleCallDetailsFetched;
